<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="complianceChecksWhitelistData"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="detail">
        <span @click="doOperation(index)">
          <Button
            v-hasPermission="[
              'monitor:complianceChecks:deleteIgnoreNoncompliantResources'
            ]"
            type="error"
            size="small"
            @click="deleteWhitelist"
            >{{ $t("ticket.list.delete") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="deleteModal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ $t("alarms.common.sureDelete") }}?</p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading_restore"
          @click="deleteIgnoreNoncompliantResources"
          >{{ $t("ticket.list.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
let tableComplianceChecksWhitelist = {};
export default {
  name: "TableComplianceChecksWhitelist",
  components: {},
  data() {
    return {
      modal_loading_restore: false,
      deleteModal: false,
      companyId: 0,
      accountId: "",
      region: "",
      resourceName: "",
      configRule: "",
      val: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      isDisable: false,
      modal_loading: false,
      stateType: ["enabled", "disabled"],
      columns: [
        {
          title: this.$t("alarms.complianceChecks.Account"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.complianceChecks.Area"),
          key: "region"
        },
        {
          title: this.$t("alarms.complianceChecks.ComplianceRules"),
          key: "configRule"
        },
        {
          title: this.$t("alarms.complianceChecks.ResourceID"),
          key: "resourceId"
        },
        {
          title: this.$t("alarms.complianceChecks.ResourceName"),
          key: "resourceName"
        },
        {
          title: this.$t("alarms.complianceChecks.ResourceType"),
          key: "resourceType"
        },
        {
          title: this.$t("alarms.complianceChecks.Operating"),
          slot: "detail"
        }
      ],
      complianceChecksWhitelistData: []
    };
  },
  beforeCreate: function() {
    tableComplianceChecksWhitelist = this;
  },
  created() {
    eventBus.$on("companyId", function(val) {
      tableComplianceChecksWhitelist.companyId = val;
    });
    eventBus.$on("accountId", function(val) {
      tableComplianceChecksWhitelist.accountId = val;
    });
    eventBus.$on("region", function(val) {
      tableComplianceChecksWhitelist.region = val;
    });
    eventBus.$on("resourceName", function(val) {
      tableComplianceChecksWhitelist.resourceName = val;
    });
    eventBus.$on("configRule", function(val) {
      tableComplianceChecksWhitelist.configRule = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableComplianceChecksWhitelist.getComplianceChecksWhitelistData();
    },
    // 分页显示数据
    /****************************************************/
    getComplianceChecksWhitelistData: function() {
      //报警规则列表分页
      this.$api.noncompliantResourcesIgnored
        .page({
          companyId: tableComplianceChecksWhitelist.companyId,
          accountId: tableComplianceChecksWhitelist.accountId,
          region: tableComplianceChecksWhitelist.region,
          resourceName: tableComplianceChecksWhitelist.resourceName,
          configRule: tableComplianceChecksWhitelist.configRule,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.complianceChecksWhitelistData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      this.getComplianceChecksWhitelistData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      this.getComplianceChecksWhitelistData();
    },
    /*****************操作**********************************/
    doOperation: function(index) {
      this.lineIndex = index;
    },
    deleteWhitelist: function() {
      this.deleteModal = true;
    },
    // 删除
    deleteIgnoreNoncompliantResources: function() {
      this.$api.noncompliantResourcesIgnored
        .deleteIgnoreNoncompliantResources({
          resourceId: this.complianceChecksWhitelistData[this.lineIndex]
            .resourceId
        })
        .then(res => {
          this.modal_loading_restore = true;
          setTimeout(() => {
            tableComplianceChecksWhitelist.getComplianceChecksWhitelistData();
            this.modal_loading_restore = false;
            this.deleteModal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/compliance_checks/complianceChecks_whitelist/TableComplianceChecksWhitelist.vue